<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Cargando ... </span>
</div>
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-success p-mr-2" (click)="returnConfirm()"></button>
        <button pButton pRipple label="{{translations.lbl_new_record}}" icon="pi pi-plus"
            class="p-button-success p-mr-2" (click)="openNew()" *ngIf="this.showInternatColumns"></button>

    </ng-template>
</p-toolbar>

<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12">
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span class="p-pl-2">{{translations.lbl_item}}:</span>
                        <span class="p-text-bold">{{itemId}} - {{item!=null && item.descri!=null?item.descri:""}} -
                            {{item!=null && item.descri!=null?item.sellUM:""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span class="p-pl-2">{{translations.lbl_collection}}:</span>
                        <span class="p-text-bold">{{albumId}} - {{itemsAlbum!=null &&
                            itemsAlbum.name!=null?itemsAlbum.name:""}}</span>
                    </div>
    
                    <div class="p-col-12" *ngIf="showInternatColumns  && selLang=='pt'">
                        <div class="p-fluid p-formgrid p-grid field">
                            <div class="p-col-12 p-md-4 field_label">
                                <span>{{translations.lbl_country}}:</span>
                            </div>
                            <p-dropdown class="p-col-12 p-md-8" id="country_selector" [options]="portugueseCountries" [(ngModel)]="selectedCountry"
                                placeholder="Seleccione una opción" optionLabel="value"
                                (onChange)="onChangeCountryPT()"></p-dropdown>
                        </div>
                    </div>
    
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span class="p-text-bold p-error">{{message}}</span>
                    </div>
                </div>

            </p-panel>
        </div>
    </div>

    <p-table #dt [value]="lstItemsTrak" [globalFilterFields]="['name']" [rowHover]="true" dataKey="id"
        styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">Contenido del album</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th  *ngIf="showInternatColumns && selLang=='pt'">
                    {{translations.lbl_create}}
                </th>
                <th style="width: 5rem;" pSortableColumn="sequence" *ngIf="this.security && this.security.levelId=='I'">
                    {{translations.lbl_id}}<p-sortIcon field="sequence">
                    </p-sortIcon>
                </th>
                <th style="width: 10rem;" pSortableColumn="name">{{translations.lbl_name}}<p-sortIcon field="name">
                    </p-sortIcon>
                </th>
                <th *ngIf="showInternatColumns && selLang=='pt'">
                    {{translations.lbl_region}}
                </th>
                <th pSortableColumn="duration" *ngIf="this.showInternatColumns">
                    {{translations.lbl_duration}}<p-sortIcon field="duration">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="length" *ngIf="this.showInternatColumns">
                    {{translations.lbl_length}}<p-sortIcon field="length">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="status" *ngIf="this.showInternatColumns">{{translations.lbl_status}}
                    <p-sortIcon field="status">
                    </p-sortIcon>

                <th style="width: 10rem;" *ngIf="this.showInternatColumns"> {{translations.lbl_file}}</th>
                <th style="width: 8rem;" *ngIf="this.showInternatColumns"></th>
                <th *ngIf="this.showInternatColumns">{{translations.lbl_download}}</th>
                <th *ngIf="this.showInternatColumns">{{translations.lbl_approve}}</th>
                <th> {{translations.lbl_play}}</th>
                <th> {{translations.lbl_stop}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr>
                <td *ngIf="showInternatColumns && selLang=='pt'">
                    <button pButton pRipple icon="pi pi-plus" (click)="createBrazilRecord(value)" [disabled]="value.id.region == 'BR' ? true : false"></button>
                </td>
                <td *ngIf="this.security && this.security.levelId=='I'">{{value.orderToPlay}}</td>
                <td>{{value.name}}</td>
                <td *ngIf="showInternatColumns && selLang=='pt'">
                    {{value.id.region ? value.id.region : ''}}
                </td>
                <td *ngIf="this.showInternatColumns">{{value.duration}}</td>
                <td *ngIf="this.showInternatColumns">{{value.length}}</td>
                <td *ngIf="this.showInternatColumns">{{value.status}}</td>

                <td *ngIf="this.showInternatColumns">{{value.fileName}}</td>
                <td *ngIf="this.showInternatColumns">
                    <button type="button" pButton pRipple icon="pi pi-pencil" [disabled]="disabledEditRules(value)"
                        class="p-button-rounded p-button-success p-mr-2" (click)="edit(value)"></button>
                    <button type="button" pButton pRipple icon="pi pi-trash" [disabled]="disabledEditRules(value)"
                        class="p-button-rounded p-button-danger" (click)="removeSelected(value)"></button>
                    <button pButton pRipple icon="pi pi-angle-double-up" [disabled]="disabledEditRules(value)"
                        class="p-button-rounded p-button-info p-mr-2" (click)="moveUp(value)" title="move Up"></button>
                    <button pButton pRipple icon="pi pi-angle-double-down" [disabled]="disabledEditRules(value)"
                        class="p-button-rounded p-button-info p-mr-2" (click)="moveDown(value)"
                        title="Move Down"></button>
                </td>
                <td *ngIf="this.showInternatColumns">
                    <button type="button" pButton pRipple icon="pi pi-download" (click)="onClickDownloadFile(value)"
                        [disabled]="checkDisabedDownload(value)"></button>
                </td>
                <td *ngIf="this.showInternatColumns">
                    <button type="button" pButton pRipple icon="pi pi-check" (click)="onClickApprove(value)"
                        [disabled]="value.status=='A' || value.fileName==null"></button>
                </td>
                <td>
                    <button type="button" pButton pRipple icon="pi pi-play" (click)="onClickPlayFile(value)"
                        *ngIf="value.fileName"
                        [disabled]="checkDisabedDownload(value) || value.readyToPlay!='READY'"></button>
                </td>
                <td>
                    <button type="button" pButton pRipple icon="pi pi-circle-off" (click)="stopFile()"
                        *ngIf="value.fileName"
                        [disabled]="checkDisabedDownload(value) || value.readyToPlay!='READY'"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{lstItemsTrak ? lstItemsTrak.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="itemDialog" [style]="{width: '750px'}" header="itemTrack" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">
            <!-- Id secuencia -->
            <div class="field p-text-bold">
                <label for="sequence">{{translations.lbl_id}} {{translations.lbl_sequence}}:</label>
                <small class="p-error" *ngIf="!sequence">{{translations.lbl_required}}</small>
                <p-inputNumber id="sequence" [(ngModel)]="sequence" mode="decimal" [max]="999"
                    [disabled]="true"></p-inputNumber>
            </div>

            <div class="field p-text-bold">
                <label for="name">{{translations.lbl_name}}:</label>
                <small class="p-error" *ngIf="!sequence">{{translations.lbl_required}}</small>
                <input type="text" pInputText id="name" [(ngModel)]="name" required autofocus maxlength="50" [disabled]="brasilConf"/>
            </div>

            <div *ngIf="showInternatColumns && selLang=='pt'"  class="field p-text-bold">
                <label for="region">{{translations.lbl_region}}:</label>
                <input type="text" pInputText *ngIf="showInternatColumns && selLang=='pt'" id="region"
                    [(ngModel)]="selectedRegion.value" [disabled]="true">
            </div>

            <div class="field p-text-bold">
                <label for="duration">{{translations.lbl_duration}}: *</label>
                <input type="text" pInputText id="duration" [(ngModel)]="duration" required autofocus maxlength="8" />
            </div>

            <div class="field p-text-bold">
                <label for="length">{{translations.lbl_length}} (KB):</label>
                <p-inputNumber id="length" [(ngModel)]="length" mode="decimal" [max]="99999"></p-inputNumber>
            </div>
            
            <div class="image-upload">
                <img [src]="imageSrc" style="max-width:300px;max-height:300px" />
                <input name="imageUrl" type="file" accept="*/*" (change)="uploadFile($event)" />
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-times"
                class="p-button-danger p-button-text" (click)="hideDialog()"></button>
            <button pButton pRipple label="{{translations.lbl_save}}" icon="pi pi-check"
                class="p-button-success p-button-text" (click)="createUpdateTrack()"></button>
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="itemDialogTrack" [style]="{width: '750px'}" header="itemTrack" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-times"
                class="p-button-danger p-button-text" (click)="hideDialogTrack()"></button>
        </ng-template>
    </p-dialog>



</div>